import { useState } from 'react';

import { RefundChargebackReportSummary as RefundChargebackReportSummaryType } from 'types/embedded/refundChargebackReport';

import { BoxStyled } from './RefundChargebackReportSummary.styled';
import { RefundChargebackReportSummaryDatagrid } from './RefundChargebackReportSummaryDatagrid/RefundChargebackReportSummaryDatagrid';
import { RefundChargebackReportSummaryDropdown } from './RefundChargebackReportSummaryDropdown/RefundChargebackReportSummaryDropdown';

export type Props = {
  summary: RefundChargebackReportSummaryType;
};

export const RefundChargebackReportSummary: React.FC<Props> = ({ summary }: Props) => {
  const [isOpen, setIsOpen] = useState(true);
  const toggleIsOpen = () => {
    setIsOpen((prev) => !prev);
  };

  if (isOpen) {
    return (
      <BoxStyled>
        <RefundChargebackReportSummaryDropdown isOpen={isOpen} toggleIsOpen={toggleIsOpen} />
        <RefundChargebackReportSummaryDatagrid summary={summary} />
      </BoxStyled>
    );
  }

  return (
    <BoxStyled>
      <RefundChargebackReportSummaryDropdown isOpen={isOpen} toggleIsOpen={toggleIsOpen} />
    </BoxStyled>
  );
};
